import { createReducer } from '../utils';
import {
  CALENDAR_EVENT_REQUEST,
  CALENDAR_EVENT_SUCCESS,
  CALENDAR_EVENT_FAILURE,
} from '../constants';

// Individual alerts should follow the format: {level: <success|info|warn|error>, message: <message>}
const initialState = {
  data: [],
  isFetching: false,
};

export default createReducer(initialState, {
  [CALENDAR_EVENT_REQUEST]: (state) => {
    return Object.assign({}, state, {
      isFetching: true,
    });
  },
  [CALENDAR_EVENT_SUCCESS]: (state, payload) => {
    return Object.assign({}, state, {
      data: payload.data,
      isFetching: false,
    });
  },
  [CALENDAR_EVENT_FAILURE]: (state) => {
    return Object.assign({}, state, {
      isFetching: false,
    });
  },
});
